import { render, staticRenderFns } from "./OnTower.vue?vue&type=template&id=35aec444"
import script from "./OnTower.vue?vue&type=script&lang=js"
export * from "./OnTower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports